import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import CardLM from "./cardLM"
import { Row } from "react-bootstrap"

export default function LabManager() {
  const LAB_MEMBERS = useStaticQuery(graphql`
    query {
      allStrapiLabMembers(sort: { fields: Status, order: ASC }, filter: {Status: {eq: "Lab Manager"}}) {
        nodes {
          Contact
          Description
          Name
          Picture {
            publicURL
            size
          }
          Status
          id
        }
      }
    }
  `)
  return (
    <>
      {LAB_MEMBERS.allStrapiLabMembers.nodes.map((LAB_MEMBER, index) => {
        return (
          <Row className="researchRow">
            <CardLM labMember={LAB_MEMBER} />
          </Row>
        )
      })}
    </>
  )
}
